const parsedCollection = {};

const addToCollection = ( key, item ) =>
{
    parsedCollection[key] = [ ...parsedCollection[key] || [], item ];
    return parsedCollection[key];
}
const initCollection = () =>
{
    Object.keys(parsedCollection).forEach( key =>
    {
        delete parsedCollection[key]
    }
    )
}
export {parsedCollection, initCollection}
export default addToCollection;